import { Injectable } from '@angular/core';
import { HttpRequestService } from '../../shared/services/http-request.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiUrlConstants } from '../../shared/constants/api_url_constants';
import { ApiResponse } from '../../shared/common-model/common.model';

import {
  soViewModelForList,
  soAddDTO,
  soClientProvideLaborInfoBaseAddDTO,
  soUpdateGeneralInfoAddUpdateDTO,
  soUpdateScopeSupervisionEACAddUpdate,
  soViewModel,
  soViewModelForDetails,
  redFlagBaseViewModel,
  redFlagAddUpdateDTO,
  redFlagDetailsBaseUpdateDTO,
  redFlagDeleteDTO,
  soRequestStatusDTO,
  soGeneralFilesViewModel,
  soVersionsViewModel,
  soScopeInstDismAddUpdateDTO,
  soPullDataDTO,
  soShortListViewModel,
  soClientFeedbackViewModel,
  soSentClientFeedbackDTO,
  soClientContactViewModel,
  soActionPermissionViewModel,
  redFlagWithContactDetails,
  soAddExhibitHouseDTO,
  soViewWithPriceWithoutPriceModel,
  soShortDetailsViewModel,
  accountCoordinatorDashboardData,
  soListDTO,
  soUpdateMoveDatesDTO,
  soMoveDateChangesBaseModel,
  soListFilterDTO,
  soViewSentClientFeedbackDTO,
  soViewSentToClientHistory,
  estimatorMarkCompleteDTO,
  SoViewPriceWithorWithoutPrice,
  SoViewPriceWithorWithoutPricePdf,
  soISDViewModelForDetails
} from '../models/service-order.model';
import { SpinnerService } from '../../shared/services/spinner.service';
import { CommonToastService } from '../../shared/services/common-toast.service';
import { ACCOUNT_TYPE_CONSTANTS, COMMON_CONSTANTS, MESSAGE_CATEGORY_CONSTATNS } from '../../shared/constants/constant';
import { clientViewModelForList } from '../../admin/models/client-management/client-model';
import { ClientService } from '../../admin/services/client-management/client.service';
import { soScopeMaterialViewModel, soScopeMaterialsBaseAddUpdateDTO } from '../models/service-order-scop-material.model';
import { soScopeEquipmentViewModel, soScopeEquipmentsAddUpdateDTO, soScopeEquipmentsBaseAddUpdateDTO } from '../models/service-order-scope-equipment.model';

@Injectable({
  providedIn: 'root'
})
export class ServiceOrderService {

  private _serviceOrderDetails$ = new BehaviorSubject<soViewModelForDetails>({} as soViewModelForDetails);
  get serviceOrderDetails$(): Observable<soViewModelForDetails> { return this._serviceOrderDetails$.asObservable(); }

  private _activeSOGenInfoTab$ = new BehaviorSubject<number>(0);
  get activeSOGenInfoTab$(): Observable<number> { return this._activeSOGenInfoTab$.asObservable(); }

  private _activeSOScopeTab$ = new BehaviorSubject<number>(0);
  get activeSOScopeTab$(): Observable<number> { return this._activeSOScopeTab$.asObservable(); }

  private _activeSOPrepareTab$ = new BehaviorSubject<number>(0);
  get activeSOPrepareTab$(): Observable<number> { return this._activeSOPrepareTab$.asObservable(); }

  private _activeSOHomeTab$ = new BehaviorSubject<number>(0);
  get activeSOHomeTab$(): Observable<number> { return this._activeSOHomeTab$.asObservable(); }

  private _changeSOStatus$ = new BehaviorSubject<boolean>(false);
  get changeSOStatus$(): Observable<boolean> { return this._changeSOStatus$.asObservable(); }

  private _soActionPermission$ = new BehaviorSubject<soActionPermissionViewModel[]>([]);
  get soActionPermission$(): Observable<soActionPermissionViewModel[]> { return this._soActionPermission$.asObservable(); }

  constructor(private httpRequestService: HttpRequestService, private spinnerService: SpinnerService,
    private commonToastService: CommonToastService, private clientService: ClientService) { }

  setServiceOrderDetails(data: soViewModelForDetails) {
    this._serviceOrderDetails$.next(data);
  }
  setActiveSOGenInfoTab(data: number) {
    this._activeSOGenInfoTab$.next(data);
  }
  setChangeSOStatus(data: boolean) {
    this._changeSOStatus$.next(data);
  }
  setActiveSOHomeTab(data: number) {
    this._activeSOHomeTab$.next(data);
  }
  setActiveSOScopeTab(data: number) {
    this._activeSOScopeTab$.next(data);
  }
  setActiveSOPrepareTab(data: number) {
    this._activeSOPrepareTab$.next(data);
  }
  setSOActionPermission(data: soActionPermissionViewModel[]) {
    this._soActionPermission$.next(data);
  }
  getAllServiceOrderList(data: soListDTO): Observable<soViewModelForList[]> {
    return this.httpRequestService.postData<soViewModelForList[]>(ApiUrlConstants.soGetAll, data);
  }
  getAllServiceOrderListByShowId(showId: any): Observable<soViewModel[]> {
    return this.httpRequestService.getData<soViewModel[]>(`${ApiUrlConstants.soGetAllListByShowId}${showId}`);
  }
  getServiceOrderById(soId: any): Observable<soViewModelForDetails> {
    return this.httpRequestService.getData<soViewModelForDetails>(`${ApiUrlConstants.soGetById}${soId}`);
  }
  getServiceOrderISDById(soId: any): Observable<soISDViewModelForDetails> {
    return this.httpRequestService.getData<soISDViewModelForDetails>(`${ApiUrlConstants.soISDGetById}${soId}`);
  }
  addSO(data: soAddDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.soAdd, data);
  }
  updateScopeSupervisionEAC(data: soUpdateScopeSupervisionEACAddUpdate): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.soUpdateScopeSupervisionEAC, data);
  }
  updateScopeMaterials(data: soScopeMaterialsBaseAddUpdateDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.soUpdateScopeMaterials, data);
  }
  getAllScopeMaterials(soId: any, isLeadman: boolean): Observable<soScopeMaterialViewModel[]> {
    return this.httpRequestService.getData<soScopeMaterialViewModel[]>(`${ApiUrlConstants.soGetAllScopeMaterials}${soId}?isLeadman=${isLeadman}`);
  }
  uploadEACFormFieldFile(data: any): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.soEACFormFileUpload, data);
  }
  downloadSoEACFormFieldFile(soId: any): Observable<any> {
    return this.httpRequestService.getFileData(`${ApiUrlConstants.soEACFormFileDownload}${soId}`);
  }
  deleteSoEACFormFile(soId: any): Observable<any> {
    return this.httpRequestService.deleteData(`${ApiUrlConstants.soEACFormdFileDelete}${soId}`);
  }
  uploadGeneralFile(data: any): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.soGeneralFileUpload, data);
  }
  downloadSoGeneralFile(id: any): Observable<any> {
    return this.httpRequestService.getFileData(`${ApiUrlConstants.soGeneralFileDownload}${id}`);
  }
  deleteSoGeneralFile(id: any): Observable<any> {
    return this.httpRequestService.deleteData(`${ApiUrlConstants.soGeneralFileDelete}${id}`);
  }
  getAllGeneralFilesByServiceOrder(id: any): Observable<soGeneralFilesViewModel[]> {
    return this.httpRequestService.getData<soGeneralFilesViewModel[]>(`${ApiUrlConstants.soGetAllGeneralFilesByServiceOrderId}${id}`);
  }
  updateSORequestStatus(data: soRequestStatusDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.soRequestStatusUpdate, data);
  }
  soRequestStatusUnwin(data: soRequestStatusDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.soRequestStatusUnwin, data);
  }
  soCreateNewVersion(id: any): Observable<ApiResponse> {
    return this.httpRequestService.putData<ApiResponse>(`${ApiUrlConstants.soCreateNewVersion}${id}`, "");
  }
  soSetActivate(id: any): Observable<ApiResponse> {
    return this.httpRequestService.putData<ApiResponse>(`${ApiUrlConstants.soSetActivate}${id}`, "");
  }
  getAllVersionBySONumber(soId: any): Observable<soVersionsViewModel[]> {
    return this.httpRequestService.getData<soVersionsViewModel[]>(`${ApiUrlConstants.soGetAllVersionBySONumber}${soId}`);
  }
  getAllSOShortList(): Observable<soShortListViewModel[]> {
    return this.httpRequestService.getData<soShortListViewModel[]>(ApiUrlConstants.soGetAllShortList);
  }
  pullSOOldData(data: soPullDataDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.soPullOldData, data);
  }
  getAllSoClientFeedbackList(soId: any): Observable<soClientFeedbackViewModel[]> {
    return this.httpRequestService.getData<soClientFeedbackViewModel[]>(`${ApiUrlConstants.soGetClientFeedbackListBySoId}${soId}`);
  }
  soSentToClient(data: soSentClientFeedbackDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.soSentToClient, data);
  }
  soViewSentToClient(data: soViewSentClientFeedbackDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.soViewSentToClient, data);
  }
  getSOClientContacts(soId: any): Observable<soClientContactViewModel[]> {
    return this.httpRequestService.getData<soClientContactViewModel[]>(`${ApiUrlConstants.soGetClientContacts}${soId}`);
  }
  getSoViewToClientHistoryListBySoId(soId: any): Observable<soViewSentToClientHistory[]> {
    return this.httpRequestService.getData<soViewSentToClientHistory[]>(`${ApiUrlConstants.soViewToClientHistoryListBySOId}${soId}`);
  }
  getSoActionPermission(soId: any): Observable<soActionPermissionViewModel[]> {
    return this.httpRequestService.getData<soActionPermissionViewModel[]>(`${ApiUrlConstants.soGetActionPermission}${soId}`);
  }
  getSoActionPermissionByServiceOrder(serviceOrderId: string) {
    this.getSoActionPermission(serviceOrderId).subscribe({
      next: (response: soActionPermissionViewModel[]) => {
        this.setSOActionPermission(response);
      },
      error: (error) => {
        this.spinnerService.hide();
        if (error?.status !== 401) {
          this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.SERVICE_ORDER, error?.message);
        }
      }
    });
  }
  updateScopeEquipments(data: soScopeEquipmentsBaseAddUpdateDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.soUpdateScopeEquipments, data);
  }
  getAllScopeEquipments(soId: any): Observable<soScopeEquipmentViewModel[]> {
    return this.httpRequestService.getData<soScopeEquipmentViewModel[]>(`${ApiUrlConstants.soGetAllScopeEquipments}${soId}`);
  }
  getRedFlagListByServiceOrder(soId: any): Observable<redFlagWithContactDetails> {
    return this.httpRequestService.getData<redFlagWithContactDetails>(`${ApiUrlConstants.soGetAllRedFlagByServiceOrderId}${soId}`);
  }
  addUpdateCustomRedFlag(data: redFlagAddUpdateDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.soRedFlagCustomAddUpdate, data);
  }
  updateRedFlagStatus(data: redFlagDetailsBaseUpdateDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.soRedFlagDetailsUpdateByUser, data);
  }
  deleteCustomRedFlagStatus(data: redFlagDeleteDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.soRedFlagCustomDelete, data);
  }

  updateScopeInstallDismantle(data: soScopeInstDismAddUpdateDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.soUpdateScopeInstDism, data);
  }
  addExhibitHouseClientIfExhibitor(data: soAddExhibitHouseDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.soAddExhibitHouseIfExhibitor, data);
  }
  getSOView(data: any): Observable<soViewWithPriceWithoutPriceModel> {
    return this.httpRequestService.postData<soViewWithPriceWithoutPriceModel>(ApiUrlConstants.soGetView, data);
  }
  //This API hits first API method, which in turn will call another URL for download///api/So/GetSOViewPDF
  //This is called from ServiceOrderViewComponent
  getSOViewPDFWithOrWithoutPrice(params: SoViewPriceWithorWithoutPricePdf): Observable<any> {
    return this.httpRequestService.postData(ApiUrlConstants.soGetViewPdf, params);
    //return this.httpRequestService.getFileDataWithParams(ApiUrlConstants.soGetViewPdfWithPrice, [{ serviceOrderId: soDetails.serviceOrderId, isWithoutPrice: soDetails.isWithoutPrice }]);
  }
  //soDownloadViewPdf
  soViewPdfDownload(params: SoViewPriceWithorWithoutPricePdf): Observable<any> {
    return this.httpRequestService.postFileData(ApiUrlConstants.soDownloadViewPdf, params);
  }
  getSOShortDetails(id: any): Observable<soShortDetailsViewModel> {
    return this.httpRequestService.getData<soShortDetailsViewModel>(`${ApiUrlConstants.soGetShortDetails}${id}`);
  }
  soSendToCityManager(id: any): Observable<ApiResponse> {
    return this.httpRequestService.putData<ApiResponse>(`${ApiUrlConstants.sendJobToCityManager}${id}`, "");
  }
  soGrabByEstimator(id: any): Observable<ApiResponse> {
    return this.httpRequestService.putData<ApiResponse>(`${ApiUrlConstants.soGrabByEstimator}${id}`, "");
  }
  soCompleteByEstimator(data: estimatorMarkCompleteDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.soCompleteByEstimator, data);
  }
  soSendAgainToEstimator(id: any): Observable<ApiResponse> {
    return this.httpRequestService.putData<ApiResponse>(`${ApiUrlConstants.soSendAgainToEstimator}${id}`, "");
  }
  getAccountCoordinatorDashboard(): Observable<accountCoordinatorDashboardData> {
    return this.httpRequestService.getData<accountCoordinatorDashboardData>(ApiUrlConstants.soGetAccountCoordinatorDashboardDetails);
  }
  soSendReminderToClient(id: any): Observable<ApiResponse> {
    return this.httpRequestService.putData<ApiResponse>(`${ApiUrlConstants.soSentReminderToClient}${id}`, "");
  }
  soReadyToSentToClientClear(soList: string[]): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(`${ApiUrlConstants.soReadyToSentToClientClear}`, soList);
  }
  soRecReminderConfirmation(id: any): Observable<ApiResponse> {
    return this.httpRequestService.putData<ApiResponse>(`${ApiUrlConstants.soRecReminderConfirmation}${id}`, "");
  }
  updateCMLayout(id: any): Observable<ApiResponse> {
    return this.httpRequestService.putData<ApiResponse>(`${ApiUrlConstants.soUpdateCMLayout}${id}`, "");
  }
  removeCMLayoutForCanceledSO(id: any): Observable<ApiResponse> {
    return this.httpRequestService.putData<ApiResponse>(`${ApiUrlConstants.soRemoveCMLayoutForCanceled}${id}`, "");
  }
  soSendToCityManagerAgain(id: any): Observable<ApiResponse> {
    return this.httpRequestService.putData<ApiResponse>(`${ApiUrlConstants.sendJobToCityManagerAgain}${id}`, "");
  }
  soGetMoveDateChangesDetails(data: soUpdateMoveDatesDTO): Observable<soMoveDateChangesBaseModel> {
    return this.httpRequestService.postData<soMoveDateChangesBaseModel>(ApiUrlConstants.soGetMoveDateChangesDetails, data);
  }
  downloadCMLayoutExcelFileData(data: any): Observable<any> {
    return this.httpRequestService.postFileData(ApiUrlConstants.jobLaborPlanAllocExcelDataByShowId, data);
  }
  soGetAllNew(data: soListFilterDTO): Observable<soViewModelForList[]> {
    return this.httpRequestService.postData<soViewModelForList[]>(ApiUrlConstants.soGetAllNew, data);
  }
  soGetAllSONumber(): Observable<string[]> {
    return this.httpRequestService.getData<string[]>(ApiUrlConstants.soGetAllSOFullNumber);
  }
  sendSMSToLaborForAvailability(id: any): Observable<ApiResponse> {
    return this.httpRequestService.putData<ApiResponse>(`${ApiUrlConstants.jobLaborPlanningSendSMSToLaborForAvailability}${id}`, "");

  }
  sendVerbalConfirmationToLaborForAvailability(id: any): Observable<ApiResponse> {
    return this.httpRequestService.putData<ApiResponse>
      (`${ApiUrlConstants.jobLaborPlanningSendVerbalConfirmationToLaborForAvailability}${id}`, "");
  }
  soMarkSOReadyForEstimator(id: any): Observable<ApiResponse> {
    return this.httpRequestService.putData<ApiResponse>(`${ApiUrlConstants.soMarkSOReadyForEstimator}${id}`, "");
  }
}
